// snippets
import React from "react";
import { CubeIcon } from "@heroicons/react/outline";
import { packClasses } from "Utils";

export default function DangerButton({
    label,
    type,
    className,
    children,
    blocking,
    ...remainder
}) {
    return (
        <button
            type={type ? type : "button"}
            className={packClasses(
                "focus:outline-none relative inline-flex justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm  focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:opacity-50",
                blocking
                    ? "bg-gray-200 hover:bg-gray-200"
                    : "bg-red-600 hover:bg-red-700",
                className ? className : ""
            )}
            {...remainder}
        >
            <CubeIcon
                className={packClasses(
                    blocking ? " opacity-1" : " opacity-0",
                    "absolute mx-auto h-5 w-5 animate-rotate-pulse text-white"
                )}
                key="icn0"
            />
            <span
                className={packClasses(blocking ? " opacity-0" : " opacity-1")}
            >
                {children ? children : label}
            </span>
        </button>
    );
}
